import get from 'lodash/get';

export const getApiError = (state) => get(state, 'error.apiError');
